export default "__VITE_ASSET__57da37e0__"